// 风险评估页面映射
export const controlMap = {
  '101': 'Chemical',
  '102': 'Chemical',
  '103': 'Chemical',
  '104': 'Chemical',
  '105': 'Chemical',
  '106': 'Chemical',
  '107': 'Industrial',
  '108': 'Industrial',
  '109': 'Boom',
  '110': 'Industrial',
  '111': 'Industrial',
  '112': 'Industrial',
  '113': 'Chemical',
  '114': 'SurfaceMine',
  '115': 'UndergroundMine',
  '116': 'TailingsPond',
  '117': 'Fireworks',
  '118': 'Port',
  '119': 'RailFreight',
  '120': 'Construction',
  '121': 'Industrial',
  '122': 'Chemical',
  '123': 'Industrial',
  '124': 'Industrial',
  '126': 'Industrial',
  '127': 'Industrial',
  '128': 'Industrial',
  '129': 'Industrial',
  '132': 'Construction',
  '133': 'Construction',
  '134': 'Construction',
  '135': 'Construction',
  '136': 'Boom',
  '137': 'Industrial',
  '138': 'Port',
  '141': 'Chemical',
  '201': 'Restaurant',
  '202': 'Hospital',
  '203': 'Tower',
  '204': 'Religion',
  '205': 'Stadium',
  '206': 'TouristPlaces',
  '207': 'School',
  '208': 'Hotel',
  '209': 'ElderlyInstitution',
  '210': 'Cultural',
  '211': 'Market',
  '212': 'VillageInCity',
  '213': 'School',
  '214': 'Cultural',
  '215': 'Cultural',
  '216': 'Hotel',
  '217': 'Market',
  '229': 'DrivingSchool',
  '301': 'Bridge',
  '302': 'Tunnel',
  '303': 'Dam',
  '304': 'Station',
  '305': 'RoadTransport',
  '306': 'GasAndChemicals',
  '307': 'Pipeline',
  '308': 'DangerRoadTransport',
  '309': 'ConstructionWaste',
  '310': 'Fishery',
  '312': 'CityLitter',
  '313': 'BulkMaterial',
  '314': 'Highway',
  '315': 'Highway',
  '316': 'Industrial',
  '317': 'Industrial',
  '318': 'RiskHydropowerStation',
  '319': 'RoadTransport',
  '320': 'WaterwayPassenger',
  '335': 'WaterwayFreightage'
}
// 安全基本信息页面映射
export const safeMap = {
  '101': 'Chemical',
  '102': 'Chemical',
  '103': 'Chemical',
  '104': 'GasStation',
  '105': 'NaturalGas',
  '106': 'NaturalGas',
  '107': 'Metallurgy',
  '108': 'Metallurgy',
  '109': 'Explosion',
  '110': 'Weave',
  '111': 'Weave',
  '112': 'Weave',
  '113': 'Electricity',
  '114': 'SurfaceMine',
  '115': 'SurfaceMine',
  '116': 'SurfaceMine',
  '117': 'FireWork',
  '118': 'Port',
  '119': 'RailFreightBase',
  '120': 'ConstructionBase',
  '121': 'Weave',
  '122': 'Chemical',
  '123': 'Weave',
  '124': 'Weave',
  '126': 'Weave',
  '127': 'Weave',
  '128': 'Weave',
  '129': 'Weave',
  '132': 'ConstructionBase',
  '133': 'ConstructionBase',
  '134': 'ConstructionBase',
  '135': 'ConstructionBase',
  '136': 'Explosion',
  '137': 'Weave',
  '138': 'Port',
  '141': 'GasStation',
  '201': 'Restaurant',
  '202': 'Hospital',
  '203': 'Tower',
  '204': 'Religion',
  '205': 'CrowdedPlace',
  '206': 'TouristPlace',
  '207': 'School',
  '208': 'Hotel',
  '209': 'CrowdedPlace',
  '210': 'CrowdedPlace',
  '211': 'Market',
  '212': 'VillageInCity',
  '213': 'School',
  '214': 'CrowdedPlace',
  '215': 'CrowdedPlace',
  '216': 'Hotel',
  '217': 'Trade',
  '229': 'DrivingSchool',
  '301': 'Bridge',
  '302': 'Tunnel',
  '303': 'Dam',
  '304': 'Station',
  '305': 'RoadTransport',
  '306': 'GasAndChemicals',
  '307': 'Pipeline',
  '308': 'DangerRoadTransport',
  '309': 'ConstructionWaste',
  '310': 'Fishery',
  '312': 'Electricity',
  '313': 'BulkMaterial',
  '314': 'Highway',
  '315': 'Highway',
  '316': 'Weave',
  '317': 'Weave',
  '318': 'Electricity',
  '319': 'RoadTransport',
  '320': 'WaterwayPassenger',
  '335': 'WaterwayFreightage'
}
// 是否划分单元
export const showUnitMap = {
  '101': true,
  '102': true,
  '103': true,
  '104': true,
  '105': true,
  '106': true,
  '107': true,
  '108': true,
  '109': true,
  '110': true,
  '111': true,
  '112': true,
  '113': true,
  '114': true,
  '115': true,
  '116': true,
  '117': true,
  '118': true,
  '119': true,
  '120': true,
  '121': true,
  '122': true,
  '123': true,
  '124': true,
  '126': true,
  '127': true,
  '128': true,
  '129': true,
  '132': true,
  '133': true,
  '134': true,
  '135': true,
  '136': true,
  '137': true,
  '138': true,
  '141': true,
  '201': true,
  '202': true,
  '203': true,
  '204': true,
  '205': true,
  '206': true,
  '207': true,
  '208': true,
  '209': true,
  '210': false,
  '211': true,
  '212': false,
  '213': true,
  '214': false,
  '215': false,
  '216': true,
  '217': true,
  '229': true,
  '301': true,
  '302': true,
  '303': true,
  '304': false,
  '305': true,
  '306': false,
  '307': false,
  '308': true,
  '309': false,
  '310': false,
  '312': true,
  '313': true,
  '314': true,
  '315': true,
  '316': true,
  '317': true,
  '318': true,
  '319': true,
  '320': false,
  '335': false
}
// 单元划分原则
const IndustrialPrinciple = `（1）针对企业的功能分区和总平面布置，从空间上将企业划分为若干单元，单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
                              （2）危险化学品储罐以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
                              （3）生产装置以防火分区为独立单元进行划分，与生产装置毗邻布置、紧密相联的辅助中间储罐、设备设施等与生产装置划分为同一单元。<div style="margin-bottom: 10px"></div>
                              （4）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
                              （5）生产厂房以有明显防火划分的独立建筑为单元。<div style="margin-bottom: 10px"></div>
                              （6）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。<div style="margin-bottom: 10px"></div>
                              （7）非生产、储存性的企业整体作为一个单元。`
const commonPrinciple = `（1）以独立建筑物为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
                          （2）若所有场所均在一个单体建筑物内则整体作为一个单元。`
export const principleMap = {
  '101': IndustrialPrinciple,
  '102': IndustrialPrinciple,
  '103': IndustrialPrinciple,
  '104': IndustrialPrinciple,
  '105': IndustrialPrinciple,
  '106': IndustrialPrinciple,
  '107': IndustrialPrinciple,
  '108': IndustrialPrinciple,
  '109': `（1）针对企业的功能分区和总平面布置，从空间上将企业划分为若干单元，单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          （2）危险化学品储罐以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
          （3）生产装置以防火分区为独立单元进行划分，与生产装置毗邻布置、紧密相联的辅助中间储罐、设备设施等与生产装置划分为同一单元。<div style="margin-bottom: 10px"></div>
          （4）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （5）生产厂房以有明显防火划分的独立建筑为单元。<div style="margin-bottom: 10px"></div>
          （6）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。`,
  '110': IndustrialPrinciple,
  '111': IndustrialPrinciple,
  '112': IndustrialPrinciple,
  '113': IndustrialPrinciple,
  '114': `（1）依据企业各区域、场所功能用途的不同划分为矿外单元和矿山（库）单元两种类型。<div style="margin-bottom: 10px"></div>
        （2）矿外单元包括运输、加工区域，是以独立建筑物为界限划分为独立单元，其中若所有场所均在一个单体建筑物内则整体作为一个单元。
        <div style="margin-bottom: 10px"></div>
        （3）矿山（库）内可整体作为一个风险单元。`,
  '115': `（1）依据企业各区域、场所功能用途的不同划分为矿外单元和矿山（库）单元两种类型。<div style="margin-bottom: 10px"></div>
        （2）矿外单元包括运输、加工区域，是以独立建筑物为界限划分为独立单元，其中若所有场所均在一个单体建筑物内则整体作为一个单元。
        <div style="margin-bottom: 10px"></div>
        （3）矿山（库）内可整体作为一个风险单元。`,
  '116': '',
  '117': `（1）针对企业的功能分区和总平面布置，从空间上将企业划分为若干单元，单元划分应涵盖企业总平面布置内涉及设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          （2）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （3）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。`,
  '118': `（1）针对港口经营企业的功能分区和总平面布置，从空间上将企业划分为若干单元，主要包括但不限于码头（含泊位）、堆场、罐区、仓库、办公楼及生产附属设施等。单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          （2）储罐区以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
          （3）码头（含泊位）以空间相对独立性，划分为不同的码头单元。<div style="margin-bottom: 10px"></div>
          （4）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （5）集装箱堆场和散货堆场以具有消防功能的支道为界限进行单元划分。<div style="margin-bottom: 10px"></div>
          （6）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。`,
  '119': `① 针对铁路货运站场的功能分区和总平面布置，从空间上将企业划分为若干单元，主要包括但不限于装卸站台、罐区、仓库、办公楼及附属设施等。单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          ② 装卸专用作业区域可划分为独立的单元。<div style="margin-bottom: 10px"></div>
          ③ 储罐区以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
          ⑤ 仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          ⑥ 其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。`,
  '120': `（1）依据建设项目施工总平面图划分为办公生活区和施工作业区两类单元。<div style="margin-bottom: 10px"></div>
        （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）施工作业区可整体作为施工作业区风险单元。`,
  '121': IndustrialPrinciple,
  '122': IndustrialPrinciple,
  '123': IndustrialPrinciple,
  '124': IndustrialPrinciple,
  '126': IndustrialPrinciple,
  '127': IndustrialPrinciple,
  '128': IndustrialPrinciple,
  '129': IndustrialPrinciple,
  '132': `（1）依据建设项目施工总平面图划分为办公生活区和施工作业区两类单元。<div style="margin-bottom: 10px"></div>
          （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
          （3）施工作业区可整体作为施工作业区风险单元。`,
  '133': `（1）依据建设项目施工总平面图划分为办公生活区和施工作业区两类单元。<div style="margin-bottom: 10px"></div>
        （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）施工作业区可整体作为施工作业区风险单元。`,
  '134': `（1）依据建设项目施工总平面图划分为办公生活区和施工作业区两类单元。<div style="margin-bottom: 10px"></div>
        （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）施工作业区可整体作为施工作业区风险单元。`,
  '135': `（1）依据建设项目施工总平面图划分为办公生活区和施工作业区两类单元。<div style="margin-bottom: 10px"></div>
        （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）施工作业区可整体作为施工作业区风险单元。`,
  '136': `（1）针对企业的功能分区和总平面布置，从空间上将企业划分为若干单元，单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          （2）危险化学品储罐以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
          （3）生产装置以防火分区为独立单元进行划分，与生产装置毗邻布置、紧密相联的辅助中间储罐、设备设施等与生产装置划分为同一单元。<div style="margin-bottom: 10px"></div>
          （4）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （5）生产厂房以有明显防火划分的独立建筑为单元。<div style="margin-bottom: 10px"></div>
          （6）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。`,
  '137': IndustrialPrinciple,
  '138': `（1）针对港口经营企业的功能分区和总平面布置，从空间上将企业划分为若干单元，主要包括但不限于码头（含泊位）、堆场、罐区、仓库、办公楼及生产附属设施等。单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          （2）储罐区以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
          （3）码头（含泊位）以空间相对独立性，划分为不同的码头单元。<div style="margin-bottom: 10px"></div>
          （4）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （5）集装箱堆场和散货堆场以具有消防功能的支道为界限进行单元划分。<div style="margin-bottom: 10px"></div>
          （6）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。`,
  '141': IndustrialPrinciple,
  '201': commonPrinciple,
  '202': commonPrinciple,
  '203': `（1）以独立建筑物为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （2）若所有场所均在一个单体建筑物内则整体作为一个单元。`,
  '204': commonPrinciple,
  '205': commonPrinciple,
  '206': `（1）依据园（景）区各区域、场所功能用途的不同进行划分。<div style="margin-bottom: 10px"></div>
        （2）除独立建筑物需划分为独立单元外。园（景）区其他区域可整体作为一个风险单元。`,
  '207': commonPrinciple,
  '208': commonPrinciple,
  '209': `（1）以独立建筑物为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （2）若所有场所均在一个单体建筑物内则整体作为一个单元`,
  '210': '',
  '211': commonPrinciple,
  '212': '',
  '213': commonPrinciple,
  '214': '',
  '215': '',
  '216': commonPrinciple,
  '217': commonPrinciple,
  '229': '',
  '301': '',
  '302': '',
  '303': '',
  '304': '',
  '305': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
        （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围。
        `,
  '306': '',
  '307': '',
  '308': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
        （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围。`,
  '309': '',
  '310': '',
  '312': IndustrialPrinciple,
  '313': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
        （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围。`,
  '314': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
          （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
          （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围`,
  '315': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
          （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
          （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围`,
  '316': IndustrialPrinciple,
  '317': IndustrialPrinciple,
  '318': IndustrialPrinciple,
  '319': '',
  '320': '',
  '335': ''
}
export const controlNameMap = {
  '101': '危险化学品生产企业',
  '102': '带储存的危险化学品经营企业',
  '103': '危险化学品使用企业',
  '104': '加油站',
  '105': '天然气站场',
  '106': '液化气储配站（含供应站）',
  '107': '冶金企业',
  '108': '有色企业',
  '109': '民用爆炸物品企业',
  '110': '建材企业',
  '121': '轻工企业',
  '111': '机械企业',
  '112': '纺织企业',
  '113': '电力企业',
  '114': '露天矿山',
  '115': '地下矿山',
  '116': '尾矿库',
  '117': '烟花爆竹企业',
  '118': '港口经营企业（泉州港口）',
  '119': '铁路货运站场',
  '120': '建筑业',
  '122': '农业与农机(农药、兽药)',
  '123': '农机(含农机作业)',
  '124': '农业与农机(农产品初加工、饲料及饲料添加剂生产)',
  '126': '机动车维修企业',
  '127': '粮食和物资储备行业',
  '128': '烟草',
  '129': '林业',
  '132': '农田水利建设',
  '133': '公路、水运工程',
  '134': '房地产业(含房地产开发、房屋征收拆迁等)',
  '135': '水利工程',
  '136': '民爆物品(爆破)',
  '137': '特种设备生产企业',
  '138': '港口经营企业（湄洲湾港口）',
  '141': '加气站',
  '201': '餐饮场所',
  '202': '医疗机构',
  '203': '房地产业（物业服务）',
  '204': '宗教场所',
  '205': '体育场馆',
  '206': '城市公园',
  '207': '学校',
  '208': '宾馆酒店（非星级）',
  '209': '养老机构和福利机构',
  '210': '文化行业',
  '211': '商贸',
  '213': '技工院校和职业培训机构',
  '214': '新闻出版',
  '215': '文物和博物馆',
  '216': '星级饭店（酒店）',
  '217': '商贸（医药及医疗器材）',
  '229': '驾校',
  '301': '城市桥梁',
  '302': '城市隧道',
  '303': '水库大坝',
  '304': '客运车站',
  '305': '旅行社',
  '306': '陆上油气长输管道企业',
  '307': '城镇燃气管道企业',
  '308': '危险货物道路运输企业',
  '309': '建筑垃圾受纳场',
  '310': '渔业船舶',
  '311': '船舶运输',
  '312': '城市垃圾处理企业',
  '313': '散装物料运输企业',
  '314': '普通货物运输企业',
  '315': '邮政(含快递)',
  '316': '城市供水企业',
  '317': '污水处理企业',
  '318': '农村水电站',
  '319': '公路客运企业',
  '320': '水路旅客运输企业',
  '335': '水路货物运输企业'
}
// // 企业是单单元还是多单元
// export const controlUnitTypeMap = {
//   '207': 'Single',
//   '109': 'Multi'
// }
// 隐患排查治理情况页面映射
export const controlComplianceMap = {
  '112': 'Weave',
  '110': 'BuildingMaterials',
  '121': 'LightIndustry',
  '111': 'MechanicalEngineering',
  '108': 'Nonferrous',
  '107': 'Metallurgy',
  '118': 'Port',
  // '202': 'Common',
  '101': 'Chemical',
  '102': 'Chemical',
  // '103': 'Common',
  // '105': 'Common',
  // '106': 'Common',
  // '104': 'Common',
  // '113': 'Common',
  // '109': 'Common',
  '114': 'SurfaceMine',
  '115': 'UndergroundMine',
  '116': 'TailingsPond',
  '117': 'Fireworks',
  '119': 'RailFreight'
  // '120': 'Common',
  // '201': 'Common',
  // '206': 'Common',
  // '207': 'Common',
  // '208': 'Common',
  // '211': 'Common'
}



// WEBPACK FOOTER //
// ./src/router/control.js